import React from 'react'
import InterfaceWrapper from './components/InterfaceWrapper'
import OrdersMain from './components/OrdersMain'

const Orders = props => {
  return <InterfaceWrapper Main={OrdersMain} {...props} />
}

export default Orders
